import { render } from "./snack.vue?vue&type=template&id=7df5a72b&scoped=true"
import script from "./snack.vue?vue&type=script&lang=js"
export * from "./snack.vue?vue&type=script&lang=js"

import "./snack.vue?vue&type=style&index=0&id=7df5a72b&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df5a72b"]])

export default __exports__